import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ContactoListado, ContactoPedido } from '../../shared/interfaces/contacto.interface';
import { skipLoading } from '../interceptors/skip-loading.context';

@Injectable({ providedIn: 'root' })
export class ContactoService {
  private readonly http = inject(HttpClient);

  listar(): Observable<{ success: boolean; data: ContactoListado[] }> {
    return this.http.get<{ success: boolean; data: ContactoListado[] }>(`${environment.apiUrl}/contacto`);
  }

  enviar(payload: ContactoPedido): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(`${environment.apiUrl}/contacto`, payload, {
      context: skipLoading(),
    });
  }
}
